import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./App";
import { TooltipLayer } from "./components/TooltipLayer";
import { AuthProvider } from "./lib/auth";
import { initTheme } from "./lib/theme";
import { hydratePrefs } from "./lib/prefs";
import "./index.css";

initTheme();
void hydratePrefs();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <TooltipLayer />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
